import React from 'react';

import { HtmlContent } from '@dndbeyond/character-components/es';

export class PropListItem extends React.PureComponent<{
    label: string;
    cols: number;
    percent: number;
    isHtml: boolean;
    className: string;
}> {
    static defaultProps = {
        cols: 2,
        isHtml: false,
        className: '',
    };

    render() {
        const { label, children, cols, percent, isHtml, className } = this.props;

        let classNames = ['ct-prop-list__item', `ct-prop-list__item--${cols}col`, className];
        if (percent) {
            classNames.push(`ct-prop-list__item--${percent}percent`);
        }

        return (
            <div className={classNames.join(' ')}>
                <div className="ct-prop-list__item-label">{label}</div>
                {typeof children === 'string' && isHtml ? (
                    <HtmlContent className="ct-prop-list__item-value" html={children} />
                ) : (
                    <div className="ct-prop-list__item-value">{children}</div>
                )}
            </div>
        );
    }
}

export class PropList extends React.PureComponent<{
    className: string;
    onClick: () => void;
}> {
    static defaultProps = {
        className: '',
    };

    handleClick = (evt) => {
        const { onClick } = this.props;

        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        onClick();
    };

    render() {
        const { children, className, onClick } = this.props;

        let classNames = ['ct-prop-list', className];

        return (
            // @ts-ignore
            <div className={classNames.join(' ')} onClick={onClick ? this.handleClick : undefined}>
                {children}
            </div>
        );
    }
}

export default PropList;
